import {Box, Chip, ChipProps, Tooltip} from "@mui/material";
import React from "react";
import {Link} from "react-router-dom";
import {User, UserRef} from "../../api";
import {useLocalization} from "@smalox/shared";
import {useTenantId} from "../../tenant";
import {UserIcon} from "../../icons";

export interface UserChipProps extends Omit<ChipProps, "label" | "icon"> {
	user: User | UserRef;
}

export function UserChip({user, ...chipProps}: UserChipProps) {
	return (
		<Chip
			icon={<UserIcon />}
			label={user.displayName}
			{...chipProps}
		/>
	);
}

export interface UserLinkChipProps {
	user?: User | UserRef;
	fallback?: string;
	tenantMember?: boolean;
}

export function UserLinkChip({user, fallback, tenantMember}: UserLinkChipProps) {
	const {t} = useLocalization();
	const tenantId = useTenantId();

	if (!user) {
		return (
			<Tooltip title={t("users.deletedUser")}>
				<Box>{fallback || t("users.deletedUser")}</Box>
			</Tooltip>
		);
	}

	if (tenantMember === false) {
		return (
			<Chip
				icon={<UserIcon />}
				label={user.displayName || user.username || user.email}
				variant="outlined"
				color="secondary"
			/>
		);
	}

	return (
		<Chip
			icon={<UserIcon />}
			label={user.displayName || user.username || user.email}
			component={Link}
			to={`/${tenantId}/users/${user.username}`}
			clickable
			variant="outlined"
			color="secondary"
		/>
	);
}
